import React from "react";
import { Box } from "@material-ui/core";
import { PropertyLocationMap } from "../../../../../../../../Components/V2";

// styles
import useStyles from "./styles";

function LocationComponent({
  locationData,
  setLoacationData,
  propretyResponseJson,
}) {
  const styles = useStyles();
  return (
    <Box className={styles.wrapperLocationComponent}>
      <PropertyLocationMap
        defaultCenter={{
          lat: +locationData.latitude,
          lng: +locationData.longitude,
        }}
        locations={[locationData]}
        onClick={(e) => {
          if (Array.isArray(e.latLng)) {
            setLoacationData({
              latitude: e.latLng[0],
              longitude: e.latLng[1],
            });
          }
        }}
        propretyResponseJson={propretyResponseJson}
      />
    </Box>
  );
}
export default LocationComponent;
